import { render, staticRenderFns } from "./MasterSearch.vue?vue&type=template&id=056d5bce&scoped=true"
import script from "./MasterSearch.vue?vue&type=script&lang=js"
export * from "./MasterSearch.vue?vue&type=script&lang=js"
import style0 from "./MasterSearch.vue?vue&type=style&index=0&id=056d5bce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056d5bce",
  null
  
)

export default component.exports